import React, { Fragment  } from 'react';

import РroofOfDelivery from '../../models/ProofOfDelivery';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import { baseUrl } from '../../api/baseUrl';

import logo from '../../assets/fd_text_logo.png';

import style from './poDModal.module.css';
import commonStyles from '../common/common.module.css';

import Moment from 'moment';
import GhaModel from '../../models/Gha';


const styles = (theme: Theme) =>

  createStyles({
    buttonsWrapper: {
      justifyContent: 'space-between',
      margin: '10px 40px 15px 40px'
    },
    whsButtonsWrapper: {
      justifyContent: 'space-between',
      margin: '10px 0px 20px 0px',
      display: 'flex',
      alignItems: 'center',
    },
    dialogTitle: {
      padding: '20px',
      borderBottom: '1px solid rgb(0, 0 ,0, 0.3)',
      marginBottom: '30px',
    },
    close: {
      width: '50px',
    },
    printButton: {
      fontSize:'40px',
    },
    returnBtnWrapper: {
      margin: '10px 0px 20px 0px',
    },
    textField: {
      height: '60px',
      marginRight: '30px',
      width: '250px',
    },
    wrapper: {
      width: '100%',
    },
    button: {
      width: '141px',
      height: '40px',
      fontSize: '3px'
    },
    buttonReturn: {
      width: '130px',
    },
    '@media only screen and (max-width: 600px)':{
      whsButtonsWrapper:{
        flexWrap: 'wrap'
      }
    },

    '@media only screen and (max-width: 411px)':{
  
      whsButtonsWrapper: {
        flexDirection: 'column',
        alignItems: 'center',
        height: 'auto'
      },
      button: {
        width: '100%',
      },
      buttonReturn: {
        width: '100%',
      },
      returnBtnWrapper: {
        textAlign: 'center'
      },
      mailWrapper: {
        justifyContent: 'flex-end',
        width:'100%' 
      },
      textField: {
        width: '100%',
        marginRight: '0px'
      },
      headerStyle: {
        paddingRight: '3px', 
        paddingLeft: '3px'
      }
    },
  });

interface PoDModalProps {
  classes: any;
  poD: Array<РroofOfDelivery>;
  modalOpen: boolean;
  eMail: string;
  eMailError: boolean;
  awb: string;
  handleClose: (modalType: string) => void;
  handleChangeMail: (event: any) => void;
  sendProofOfDelivery: () => void;
  printProofOfDelivery: () => void;
  gha: GhaModel;
  userRole?: string;
  goodsValue: boolean;
};

const poDModal = ( props: PoDModalProps ) => {
  let logo;
  if(props.poD[0]) {
    logo = props.poD[0].gha_info.logo ? require(`../../${props.poD[0].gha_info.logo}`) : require(`../../assets/fd_text_logo.png`);
  }

  const { classes } = props;

  const { innerWidth: width } = window;

  const HEADER_STYLE_SMALL =  { paddingRight: '3px', paddingLeft: '3px' };
  const headerStyle = innerWidth < 411 ? HEADER_STYLE_SMALL : {};

  function titleContent(pod: РroofOfDelivery, partsCounter: {value: number}): string | JSX.Element {

    const poNumber: string = pod.return_type ? pod.po_number + ` (Ret)` : pod.po_number;

    let returnedToDriver;
    
    if(pod.returned) {
      returnedToDriver = <span className={style.errorText}>Returned to driver</span>;
    }

    if(!pod.awb_delivered_in_parts) {

      if(pod.returned) {
    
        return <span>{poNumber}  {returnedToDriver}</span>;
      } else {

        return <span> <span>Shipment delivered complete - </span> {poNumber} </span>;
      }
    }


    return <span>Part { partsCounter.value++ } - { poNumber } {returnedToDriver}</span>;
  }
    
  let partsCounter = {value: 1};

  const content: Array<JSX.Element> = props.poD.map((po, index) => {

    const title: string | JSX.Element = titleContent(po, partsCounter);

    return (
      <div key={ index } className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }> Shipment</h3>
        <div className={ style.titlePart } >{ title }</div>
        <MaterialTable 

          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
          
          columns={[
            { title: 'Date', field: 'date_delivery', headerStyle: headerStyle, cellStyle: headerStyle,
              render: (rowData: РroofOfDelivery) => {
                let date;
                if(rowData.returned) {
                  date = rowData.returned_awb_date;
                } else if(rowData.date_delivery) {
                  date = rowData.date_delivery;
                } else {
                  throw new Error(`Awb ${rowData.awb_code}-${rowData.awb_number} is not delivered nor returned`);
                }
                return <span>{ Moment(date).format('DD-MMM-YY').toUpperCase() }</span>;
              }
            },
            { title: 'Check-In', field: 'checkin',  headerStyle: headerStyle, cellStyle: headerStyle,
              render: (rowData: РroofOfDelivery) => {
                if (rowData.checkin) {
                  const hours: string = rowData.checkin.slice(0,2);
                  const minute: string = rowData.checkin.slice(2,4);
                  return <span>{ hours }:{ minute }</span>;
                };
              }
            },
            { title: 'Check-Out', field: 'checkout', headerStyle: headerStyle, cellStyle: headerStyle,
              render: (rowData: РroofOfDelivery) => {
                if( rowData.checkout) {
                  const hours: string = rowData.checkout.slice(0,2);
                  const minute: string = rowData.checkout.slice(2,4);
                  return <span>{ hours }:{ minute }</span>;
                }
              }
            },
            { title: 'Driver Info', field: '' , headerStyle: headerStyle, cellStyle: headerStyle,
              render: (rowData: РroofOfDelivery) => {
                return (
                  <span>
                    <div>{ rowData.driver_name }</div>
                    <div>{ rowData.delivery_company_name }</div>
                  </span>
                )
              }
            },
            { title: 'Pcs', field: '' ,  headerStyle: headerStyle, cellStyle: headerStyle,
              render: (rowData: РroofOfDelivery) => {
                return (
                  <span>
                    { rowData.returned ? 
                      <span>0 / { rowData.total_pieces }</span> : 
                    <span>{ rowData.delivered_pieces }/{ rowData.total_pieces }</span>
                  }
                  </span>
                )
              }
            }
          ]}

          data={ [po] }

          options = {{
            paging: false,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
            showTitle: false,
            toolbar: false,
            sorting: false
          }}
        />
        <div className={ style.exception }>
          <span>The undersigned acknowledged the receipt of goods complete and in good condition unless exception noted.<br></br> </span>
          <div><span>{ props.poD[0].exceptions_noted ? "EXCEPTION NOTED:" : "No Exceptions" }</span>
          { po.exceptions_noted &&
            <span>Exception has been noted at time of delivery.</span>
          }</div>
          { props.goodsValue &&
           <span>Dangerous Goods Declaration received.</span>
          }
        </div>
        <div className={ style.details }>
          <div>
            <div className={ style.bordered }>
              { (po.returned ? po.returned_awb_signature_key : po.driver_signature_key) ?
                <img className={ style.signature }
                  src={ `${baseUrl}pickup_order/${po.po_number}/awb/${po.awb_code}/${po.awb_number}/signature`}
                /> :
                <span>No signature</span>
              }
            </div>
            <div className={ style.description }>Trucker Signature</div>
          </div>
          <div>
            <div className={ style.bordered }>
              <span>{ po.gha_counter_user }</span>
            </div>
          <div className={ style.description }>{ po.gha_company_name } Counter</div>
          </div>
          <div>
            <div className={ style.bordered }>
              <span>{ po.returned? po.awb_returned_gha_wh_user_name: po.gha_wh_user_name }</span>
            </div>
          <div className={ style.description }>{ po.gha_company_name } Warehouse</div>
          </div>
        </div>
      </div>
    )
  });

  const dialogTitle: JSX.Element = (
    <div className={ style.wrapperTitle }>
       <img alt="logo" src={ logo } className={ style.logoImg } />
       <div className={ style.wrapperTitleInner}>
         <div>
            <div className={ style.titleText }>Proof Of Delivery</div>
            <div className={ style.titleNumber }>{ props.awb }</div>
         </div>
         { props.userRole !== 'whs' && 
        <IconButton aria-label="Close" className={ classes.close } onClick={ () => props.handleClose('pod') } >
            <CloseIcon color='primary' />
        </IconButton>
       }
       </div>
    </div>  
  )

  const action: JSX.Element = (
    <Fragment>
      <Button className={ classes.button } color="primary" variant="contained" onClick={ props.printProofOfDelivery } >Print</Button>
        <div className={ style.mailWrapper }>
          <div className={ commonStyles.inputLabelWrapper }>
            <label className={ commonStyles.inputLabel }>-- Enter e-Mail</label>
            <TextField
              id="mail"
              className={ classes.textField }
              value={ props.eMail }
              onChange={ props.handleChangeMail }
              error={ props.eMailError }
              helperText={ props.eMailError ? 'incorrect email format' : '' }
            />
          </div>
          <Button className={ classes.button } color="primary" variant="contained" onClick={ props.sendProofOfDelivery } >Send e-Mail</Button>
        </div>
    </Fragment>
  )

  const podComponent: JSX.Element = props.userRole === 'whs' ? (
  <div className={classes.wrapper}>
    <div className={ classes.dialogTitle }>{dialogTitle}</div>
    <div>{content}</div>
    <div>
      <div className={ classes.whsButtonsWrapper }>{action}</div>
      <div className={ classes.returnBtnWrapper}>
        <Button className={ classes.buttonReturn} color='primary' variant='contained' onClick={() => props.handleClose('pod')}>Exit</Button>
      </div>
   </div>
  </div>
  ) : (
    <Dialog
			open={ props.modalOpen }
			onClose={ () => props.handleClose('pod') }
			aria-labelledby="form-dialog-title"
			maxWidth={ 'xl' }
		>
			<DialogTitle className={ classes.dialogTitle } id="form-dialog-title">{ dialogTitle }</DialogTitle>
			<DialogContent>
			  <div>
			    { content } 
				</div>
			</DialogContent>
      <DialogActions className={ classes.buttonsWrapper } >
        { action }
      </DialogActions>
    </Dialog>
  )
  return ( 
    <Fragment>
      {podComponent}
    </Fragment>
		
  );
};

export default withStyles(styles)(poDModal);